/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { InvitationContextResponseInvitationInviter } from './';
import {
    InvitationContextResponseInvitationInviterFromJSON,
    InvitationContextResponseInvitationInviterFromJSONTyped,
    InvitationContextResponseInvitationInviterToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationContextResponseInvitation
 */
export interface InvitationContextResponseInvitation {
    /**
     * 
     * @type {InvitationContextResponseInvitationInviter}
     * @memberof InvitationContextResponseInvitation
     */
    inviter?: InvitationContextResponseInvitationInviter;
    /**
     * Whether the inviter is an admin
     * @type {boolean}
     * @memberof InvitationContextResponseInvitation
     */
    adminInvitation?: boolean;
}

/**
 * Check if a given object implements the InvitationContextResponseInvitation interface.
 */
export function instanceOfInvitationContextResponseInvitation(value: object): value is InvitationContextResponseInvitation {
    return true;
}

export function InvitationContextResponseInvitationFromJSON(json: any): InvitationContextResponseInvitation {
    return InvitationContextResponseInvitationFromJSONTyped(json, false);
}

export function InvitationContextResponseInvitationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseInvitation {
    if (json == null) {
        return json;
    }
    return {
        
        'inviter': json['inviter'] == null ? undefined : InvitationContextResponseInvitationInviterFromJSON(json['inviter']),
        'adminInvitation': json['adminInvitation'] == null ? undefined : json['adminInvitation'],
    };
}

export function InvitationContextResponseInvitationToJSON(value?: InvitationContextResponseInvitation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'inviter': InvitationContextResponseInvitationInviterToJSON(value['inviter']),
        'adminInvitation': value['adminInvitation'],
    };
}

